"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = exports.isTeacherUser = exports.isStudentUser = void 0;
const axios_1 = require("axios");
const isStudentUser = () => getCookie('ugm-type-cookie') === 'student';
exports.isStudentUser = isStudentUser;
const isTeacherUser = () => getCookie('ugm-type-cookie') === 'teacher';
exports.isTeacherUser = isTeacherUser;
const handleError = (e) => {
    if (axios_1.default.isAxiosError(e)) {
        const err = e;
        if (err.response) {
            return err.response.data;
        }
    }
};
exports.handleError = handleError;
/**
 * @see https://gist.github.com/hunan-rostomyan/28e8702c1cecff41f7fe64345b76f2ca
 */
const getCookie = (name) => {
    var _a;
    return (_a = document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(c => c.substring(0, name.length + 1) === `${name}=`)
        .map(c => decodeURIComponent(c.substring(name.length + 1)))[0]) !== null && _a !== void 0 ? _a : null;
};
//# sourceMappingURL=util.js.map